import { NumberValue, VALUE_TYPE } from "Components/NumberValue";

import { DeductibleValue } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Deductible";
import { ProductDetail } from "Components/InsuranceDetailsCard/ProductDetailsTable/interface";
import { TractorProduct } from "Store/interfaces/products/checkout/riskProducts/vehicleProducts/TractorProduct";
import React from "react";

export const tractorDetailsList = (
  product: TractorProduct,
  types: any,
  lang: string,
): ProductDetail[] => [
  {
    name: "deductible",
    value: (
      <DeductibleValue
        value={product.priceSpecifications.deductible.code ?? "??"}
      />
    ),
  },
  {
    name: "coverageAmount",
    value: <NumberValue type={VALUE_TYPE.NOK} value={product.coverageAmount} />,
  },
  {
    //modelYear presents the year the tractor first was registered
    //not the actual model year
    name: "firstRegistered",
    value: product.modelYear,
  },
  {
    name: "tractorType",
    value: types.tractorTypes[product.tractorType][lang],
  },
  {
    name: "damageCountRecentYears",
    value: product.damageCountRecentYears ?? 0,
  },
  {
    name: "yearOfLastDamage",
    value: product.yearOfLastDamage,
    hidden: product.damageCountRecentYears === 0,
  },
];
